import { c as _c } from "react/compiler-runtime";
import { BadgeItem } from '@/app/components/tags/badge';
import type { ProductBadgeProps, ProductBadgeVariant } from '@/app/cv/components/sections/products/types';
const variantClassName: Record<ProductBadgeVariant, string> = {
  red: 'bg-red-100 text-red-500 before:border-red-500',
  gray: 'bg-silver-500 text-gray-900 before:border-gray-900'
};
export const ProductBadge = t0 => {
  const $ = _c(10);
  let badgeProps;
  let label;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      theme: t1,
      variant: t2,
      label,
      ...badgeProps
    } = t0);
    $[0] = t0;
    $[1] = badgeProps;
    $[2] = label;
    $[3] = t1;
    $[4] = t2;
  } else {
    badgeProps = $[1];
    label = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const theme = t1 === undefined ? "light" : t1;
  const variant = t2 === undefined ? "red" : t2;
  if (!label) {
    return null;
  }
  const t3 = variantClassName[variant];
  let t4;
  if ($[5] !== badgeProps || $[6] !== label || $[7] !== t3 || $[8] !== theme) {
    t4 = <BadgeItem id={label} label={label} theme={theme} badgeClassName={t3} {...badgeProps} />;
    $[5] = badgeProps;
    $[6] = label;
    $[7] = t3;
    $[8] = theme;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};